module.exports = __webpack_public_path__ + "fonts/g2hf7Qlm.woff2";